angular.module('taric.quota.view', ['common.template.geoarea.popup', 'common.filter.commoditycode', 'common.filter.decimalNumber', 'common.helper', 'common.filter.specialCharacterToHtml'])
    .controller('ViewTaricQuotaController', function (quotaDefinitionExtendedInfo, simulationDate, country, showCancelButton, GeographicalAreaModel, $uibModal, $uibModalInstance, $state, CONSTANTS, CommonHelper, $rootScope, $timeout, $scope, $filter) {
        var viewTaricQuotaCtrl = this;
        viewTaricQuotaCtrl.selectedRow = quotaDefinitionExtendedInfo;
        viewTaricQuotaCtrl.selectedTab = {
            activeIndex: 0,
            balancesIndex: 0,
            statusIndex: 1,
            commoditiesIndex: 2
        };
        if (viewTaricQuotaCtrl.selectedRow !== null){
            viewTaricQuotaCtrl.dateFormat = CONSTANTS.dateFormat;
            viewTaricQuotaCtrl.selectedRow.displayedBalances = CommonHelper.loadDataPerTablePage(viewTaricQuotaCtrl.selectedRow.quotaBalanceEvents, 1);
            viewTaricQuotaCtrl.selectedRow.associatedCommodityCodes  = CommonHelper.loadDataPerTablePage(viewTaricQuotaCtrl.selectedRow.quotaAssociatedCommodities, 1);
            viewTaricQuotaCtrl.itemsPerPage =  CONSTANTS.rowsPerPage;
            viewTaricQuotaCtrl.showCancelButton = showCancelButton;
            viewTaricQuotaCtrl.balancesTablePageChanged = function (page){
                viewTaricQuotaCtrl.selectedRow.displayedBalances = CommonHelper.loadDataPerTablePage(viewTaricQuotaCtrl.selectedRow.quotaBalanceEvents, page);
            };

            viewTaricQuotaCtrl.commodityCodesTablePageChanged = function (page){
                viewTaricQuotaCtrl.selectedRow.associatedCommodityCodes  = CommonHelper.loadDataPerTablePage(viewTaricQuotaCtrl.selectedRow.quotaAssociatedCommodities, page);
            };
        }

        viewTaricQuotaCtrl.openOriginPopup = function (size, origin){
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/geo-area/geoarea-popup.tmpl.html',
                controller: 'GeographicalAreaPopupController as geoAreaPopupCtrl',
                size: size,
                resolve: {
                    geoAreaMemberships: function () {
                        return GeographicalAreaModel.queryMembershipByGroupId(origin, simulationDate);
                    },
                    origin: function () {
                        return origin;
                    }
                }
            });
        };

        viewTaricQuotaCtrl.close = function (){
            $uibModalInstance.dismiss('Close');
        };

        viewTaricQuotaCtrl.selectCommodityCode = function (commodityCode) {
            var pCo = null;
            if (country && country.length === 2) {
                pCo = country;
            } else if (viewTaricQuotaCtrl.selectedRow.quotaHead.origin.id.length === 2) {
                pCo = viewTaricQuotaCtrl.selectedRow.quotaHead.origin.id;
            }

            var pSd = CommonHelper.getRestDateString(new Date());
            if (pSd < viewTaricQuotaCtrl.selectedRow.quotaHead.startDate ||
                (viewTaricQuotaCtrl.selectedRow.quotaHead.endDate !== null && pSd > viewTaricQuotaCtrl.selectedRow.quotaHead.endDate)) {
                pSd = viewTaricQuotaCtrl.selectedRow.quotaHead.startDate;
            }

            $state.go('taric.measure.mcc', {
                frm: 'taric.quota.view',
                cc: CommonHelper.removeSpaceCharacters(commodityCode),
                sd: CommonHelper.getBookmarkDateString(pSd),
                d: 'I',
                co: pCo
            });
        };

        $rootScope.$on('$translateChangeSuccess', function () {

            //This is just a workaround to force the page to re-render the pagination items with translated texts
            viewTaricQuotaCtrl.itemsPerPage = 99999999;
            $timeout(function(){
                viewTaricQuotaCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            }, 100);
        });

        // print pdf
        viewTaricQuotaCtrl.print = function(options) {
            $rootScope.$broadcast('startSpinningPrint');
            $scope.$apply();

            // wait 1s before rendering
            setTimeout(function(){

                // load documents
                var doc = [];
                CommonHelper.htmlTableToPdf(doc, document.getElementById('quotaDetailGeneralInfo'), options);
                doc.push ({ text: '\n' });

                var title = "";
                if (viewTaricQuotaCtrl.selectedTab.activeIndex === viewTaricQuotaCtrl.selectedTab.balancesIndex) {
                    title = $filter('translate')('i8n.qqry.tqa.view.tab1.label');
                    if (viewTaricQuotaCtrl.selectedRow.quotaBalanceEvents.length > 0) {
                        CommonHelper.htmlTableToPdf(doc, document.getElementById('exportBalancesTable'), options);
                    }
                } else if (viewTaricQuotaCtrl.selectedTab.activeIndex === viewTaricQuotaCtrl.selectedTab.statusIndex) {
                    title = $filter('translate')('i8n.qqry.tqa.view.tab2.label');
                    if (viewTaricQuotaCtrl.selectedRow.quotaEvents.length > 0) {
                        CommonHelper.htmlTableToPdf(doc, document.getElementById('exportStatusTable'), options);
                    }
                } else if (viewTaricQuotaCtrl.selectedTab.activeIndex === viewTaricQuotaCtrl.selectedTab.commoditiesIndex) {
                    title = $filter('translate')('i8n.qqry.tqa.view.tab4.label');
                    if (viewTaricQuotaCtrl.selectedRow.quotaAssociatedCommodities.length > 0) {
                        CommonHelper.htmlTableToPdf(doc, document.getElementById('exportCommoditiesTable'), options);
                    }
                }

                CommonHelper.printPlainDocument({
                    contents: doc,
                    logo: options.logo,
                    validDate: $filter('date')(simulationDate, CONSTANTS.dateFormat),
                    title: title
                }, 'p').then(() => {
                    $rootScope.$broadcast('stopSpinningPrint');
                }, (error) => {
                    $rootScope.$broadcast('stopSpinningPrint');
                });

            }, 1000);
        };

        $scope.$on('printDocument', function(event, data) {

            CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, viewTaricQuotaCtrl.print, true);
        });
    });



// WEBPACK FOOTER //
// ./app/taric/quota/view/quota-view.js